import script from "./VideoUploadField.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoUploadField.vue?vue&type=script&setup=true&lang=js"

import "./VideoUploadField.vue?vue&type=style&index=0&id=64b9dd44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b9dd44"]])

export default __exports__